<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">信息维护</span>
            </div>
            <div class="box-cont">
                <el-form :model="form1" ref="queryForm" label-width="140px">
                    <el-row>
                        <el-col :span="12">
                    <el-form-item label="检查(承办)机关:" prop="jcjg">
                        <el-input
                        v-model="form1.jcjg"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item label="缴罚款地点:" prop="jkdd">
                        <el-input
                        v-model="form1.jkdd"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="检查执行部门:" prop="jcjg1">
                        <el-input
                        v-model="form1.jcjg1"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="复议机关1:" prop="fyjg1">
                        <el-input
                        v-model="form1.fyjg1"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="地址:" prop="c_address">
                        <el-input
                        v-model="form1.c_address"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <!-- <el-col :span="12">
                    <el-form-item label="复议机关2:" prop="fyjg2">
                        <el-input
                        v-model="form1.fyjg2"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-form-item label="局地址:" prop="ju_address">
                        <el-input
                        v-model="form1.ju_address"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="联系人:" prop="c_people">
                        <el-input
                        v-model="form1.c_people"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="上诉法院名称:" prop="qsjg">
                        <el-input
                        v-model="form1.qsjg"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="联系人电话:" prop="c_phone">
                        <el-input
                        v-model="form1.c_phone"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="联系人电话2:" prop="c_phone2">
                        <el-input
                        v-model="form1.c_phone2"
                        placeholder="请输入"
                        clearable
                        
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="QQ:" prop="c_qq">
                        <el-input
                        v-model="form1.c_qq"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="电子邮箱:" prop="c_email">
                        <el-input
                        v-model="form1.c_email"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="邮政编码:" prop="c_yzbm">
                        <el-input
                        v-model="form1.c_yzbm"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="传真号码:" prop="c_fax">
                        <el-input
                        v-model="form1.c_fax"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="负责人:" prop="c_fzr">
                        <el-input
                        v-model="form1.c_fzr"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="办公室电话:" prop="c_bgdh">
                        <el-input
                        v-model="form1.c_bgdh"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="手机:" prop="c_sj">
                        <el-input
                        v-model="form1.c_sj"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="办公时间:" prop="c_bgsj">
                        <el-input
                        v-model="form1.c_bgsj"
                        placeholder="请输入"
                        clearable
                        
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="印章图片上传:" prop="yinzhang">
                        <el-upload
                                class="avatar-uploader"
                                action="#"                 
                                :before-upload="beforeAvatarUpload"
                                :show-file-list="false" 
                                >
                            <img v-if="form1.yinzhang" :src="form1.yinzhang" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <el-button type="primary" @click="onSubmitTp">上传印章</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="印章直径:" prop="yzsize">
                        <el-input style="width:80%;"
                        v-model="form1.yzsize"
                        placeholder="请输入"
                        clearable
                        
                        />&nbsp;mm
                    </el-form-item>
                    <el-form-item label="现场笔录:" prop="xcbl">
                        <el-checkbox label="禁止编辑" v-model="form1.bl_wsbj"></el-checkbox>
                        <el-checkbox label="启用计时" v-model="form1.bl_js"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="启用参数设置:">
                        <el-checkbox label="启用套打" v-model="form1.b_taoda"></el-checkbox>
                        <el-checkbox label="相对人区分科室" v-model="form1.b_gzbm"></el-checkbox>
                        <el-checkbox label="启用编号申请" v-model="form1.b_lsh"></el-checkbox>
                        <el-checkbox label="启用文号申请" v-model="form1.b_wh"></el-checkbox>
                    </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item style="text-align:right;">
                        <el-button type="primary" size="small"  @click="submit">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">其他信息维护</span>
            </div>
            <div class="box-cont">
                <el-form :model="form2" ref="queryForm2" label-width="140">
                    <el-row>
                        <el-col :span="12">
                    <el-form-item label="导入相对人:" prop="drxdr">
                        <el-upload
                            class="upload-demo"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="3"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            <el-button size="small" type="warning">选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="导入相对人2:" prop="drxdr2">
                        <el-upload
                            class="upload-demo"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="3"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            <el-button size="small" type="warning">选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                    </el-row>
                    <el-form-item style="text-align:right;">
                        <el-button type="primary" size="small" @click="submit2">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            jcjg:'',
            form1:{},
            form2:{},
            checkList:[],
            imageUrl:'',
            fileList:[],
            //印章
            fileName:'',
            files:{},
            imgUrl:'',
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '系统信息维护'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl
        this.getList()
    },
    methods: {
        getList(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getIdtcontent`,
                data:{
                    title:this.jcjg
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.form1 = res.data.data
                    for(var i in this.form1){
                        if(i == 'bl_wsbj' || i == 'bl_js' || i == 'b_taoda' || i == 'b_gzbm'|| i == 'b_lsh'|| i == 'b_wh'){
                            if(this.form1[i] == 'True' || this.form1[i] == '1' || this.form1[i] == 1){
                                this.form1[i] = true
                            }else if(this.form1[i] == 'False' || this.form1[i] == '0' || this.form1[i] == 0){
                                this.form1[i] = false
                            }
                        }
                    }
                    console.log(this.form1)
                    if(res.data.data.yinzhang){
                        this.imgUrl = res.data.data.yinzhang
                        this.$set(this.form1,'yinzhang','https://dapc1.scqwszfd.cn:8123'+res.data.data.yinzhang)
                    }
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })   
        },
        beforeAvatarUpload(file) {
            console.log(file)
            this.files = file;
            const isJPEG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isJPG = file.type === 'image/jpg'
            const isGIF = file.type === 'image/GIF'
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!(isJPEG || isPNG || isJPG || isGIF)) {
                this.$message.error('上传图片只能是 JPEG/PNG/JPG/GIF 格式!')
                return false // 返回false不会自动上传
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false // 返回false不会自动上传
            }
            this.fileName = file.name;
            this.$set(this.form1,'yinzhang',URL.createObjectURL(file));
            return false // 返回false不会自动上传
        },
        async onSubmitTp () {
            this.imgUrl = ''
            console.log(this.files)
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的图片！')
                return false
            }
            let fileFormData = new FormData();
            //fileFormData.append('file',URL.createObjectURL(this.file9) );//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            fileFormData.append('file',this.files );
            // fileFormData.append('dm',this.form.dm );
            let config = {
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            }

            this.$axios.post(this.baseUrl+`/login/uploadXcFile`,fileFormData, config)
            .then(res => {
                console.log(res.data)
                if(res.data.error == 0){
                    console.log(res.data.filenewname)
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.imgUrl = res.data.filenewname
                }
            }).catch(err => {
                console.log(err)
                this.$message({
                    message: '上传失败',
                    type: 'error'
                });
            })
        },
        submit(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/editTcontent`,
                data: {
                    jkdd: this.form1.jkdd,
                    fyjg1: this.form1.fyjg1,
                    fyjg2: this.form1.fyjg2,
                    qsjg: this.form1.qsjg,
                    title: this.jcjg,
                    jcjg: this.form1.jcjg,
                    ju_address: this.form1.ju_address,
                    c_address: this.form1.c_address,
                    c_people: this.form1.c_people,
                    c_phone: this.form1.c_phone,
                    c_phone2: this.form1.c_phone2,
                    c_qq: this.form1.c_qq,
                    c_fax: this.form1.c_fax,
                    c_email: this.form1.c_email,
                    c_yzbm: this.form1.c_yzbm,
                    c_fzr: this.form1.c_fzr,
                    c_bgdh: this.form1.c_bgdh,
                    c_sj: this.form1.c_sj,
                    c_bgsj: this.form1.c_bgsj,
                    bl_js: this.form1.bl_js ? '1' : '0',
                    bl_wsbj: this.form1.bl_wsbj ? '1' : '0',
                    b_taoda: this.form1.b_taoda ? '1' : '0',
                    b_gzbm: this.form1.b_gzbm ? '1' : '0',
                    b_lsh: this.form1.b_lsh ? '1' : '0',
                    b_wh: this.form1.b_wh ? '1' : '0',
                    yzSize: this.form1.yzSize,
                    yinzhang:this.imgUrl,
                },
                headers: { 
                    "Content-Type": "application/json"
                }
            }).then(res => {
                console.log(res)
                if(res.data.code == 0){
                    this.$message({
                        message: '系统信息维护成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: '更新失败，请重新填写',
                        type: 'error'
                    });
                }
            }).catch(res => {
                this.$message({
                    message: '更新失败，请重新填写',
                    type: 'error'
                });
            })
        },
        submit2(){},
        handleAvatarSuccess(){},
        handlePreview(){},
        handleRemove(){},
        beforeRemove(){},
        handleExceed(){},
    }
}
</script>


<style scoped>
</style>